"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var getDiversityName = function getDiversityName(diversity) {
  if (diversity.otherStatus) {
    return "".concat(diversity.categoryName, " (").concat(diversity.otherStatus, ")");
  }
  if (diversity.statusName) {
    return "".concat(diversity.categoryName, " (").concat(diversity.statusName, ")");
  }
  return diversity.categoryName;
};
var _default = getDiversityName;
exports.default = _default;